import { activationSteps } from "../../helpers";
import { StepType } from "../../types";

export default function Stepper({ currentStep }: { currentStep: StepType }) {
  const allMainSteps = activationSteps().filter((step) => step.isMainStep);

  return (
    <>
      <nav
        aria-label="Progress"
        className="tw-flex tw-items-center tw-justify-center"
      >
        <p className="tw-text-sm tw-font-medium">
          Step {currentStep.step} of {allMainSteps.length}
        </p>
        <ol className="tw-ml-6 tw-flex tw-items-center tw-space-x-5">
          {allMainSteps.map((step, index) => (
            <li key={step.step}>
              {index + 1 < currentStep.step ? (
                <div className="tw-block tw-size-3 tw-rounded-full tw-bg-blue-600 tw-hover:tw-bg-blue-900" />
              ) : index + 1 === currentStep.step ? (
                <div
                  aria-current="step"
                  className="tw-relative tw-flex tw-items-center tw-justify-center"
                >
                  <span
                    aria-hidden="true"
                    className="tw-absolute tw-flex tw-size-5 tw-p-px"
                  >
                    <span className="tw-size-full tw-rounded-full tw-bg-blue-200" />
                  </span>
                  <span
                    aria-hidden="true"
                    className="tw-relative tw-block tw-size-2.5 tw-rounded-full tw-bg-blue-600"
                  />
                  <span className="tw-sr-only" />
                </div>
              ) : (
                <div className="tw-block tw-size-3 tw-rounded-full tw-bg-gray-200 tw-hover:tw-bg-gray-400"></div>
              )}
            </li>
          ))}
        </ol>
      </nav>
    </>
  );
}
